import { render, staticRenderFns } from "./Screen1.vue?vue&type=template&id=64c91c70&scoped=true&"
import script from "./Screen1.vue?vue&type=script&lang=js&"
export * from "./Screen1.vue?vue&type=script&lang=js&"
import style0 from "./Screen1.vue?vue&type=style&index=0&id=64c91c70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c91c70",
  null
  
)

export default component.exports